import { FFContext } from '../context/FFContext';
import { useContext } from 'react';
import { getFlagsSubset } from '../util/getFlagsSubset';
export const useFeatureFlags = (flagIdentifiers) => {
    const { flags } = useContext(FFContext);
    if (flagIdentifiers) {
        return getFlagsSubset(flags, flagIdentifiers);
    }
    return flags;
};
